import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { API_RESPONSE_STATUS } from '../../../../../../config/constant';

export default function Notification({ status, onCancel }) {
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log('registerFormStatus :>> ', status);
  }, [status]);

  return (
    <div className="register-form-notification">
      <div className="register-form-notification__container">
        <figure className="register-form-notification__logo">
          <img
            src="/svg/home/register-form/form-success-logo.svg"
            alt="Success notification logo"
          />
        </figure>
        <div className="register-form-notification__message">
          {status === API_RESPONSE_STATUS.SUCCESS ? (
            <>
              <span className="register-form-notification__icon">
                <img
                  src="/svg/home/register-form/success-icon.svg"
                  alt="Success tick"
                />
              </span>
              <p>
                We well received your information and our team will reach out to
                you shortly.
              </p>
            </>
          ) : (
            <p className="register-form-notification__message--fail">
              Server error! Please try again later!
            </p>
          )}
        </div>
        <p>Have a nice day!</p>
        <button
          type="button"
          className="register-form-notification__exit-btn"
          onClick={onCancel}
        >
          {status === API_RESPONSE_STATUS.SUCCESS ? 'Great' : 'Ok'}
        </button>
      </div>
    </div>
  );
}

Notification.propTypes = {
  status: PropTypes.number.isRequired,
  onCancel: PropTypes.func.isRequired
};
